// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__15i-s","buttons":"Footer_buttons__3xiAy"};